import type { RouteRecordRaw } from 'vue-router'

// Company settings now live under the unified Settings (/settings/*).
// Keep the old path as a tab-aware redirect so bookmarks & deep links still work.
export const companySettingsRoutes: RouteRecordRaw[] = [
  {
    path: '/pages/company-settings',
    redirect: (to) => {
      const tab = String(to.query.tab || '')
      if (tab === 'Billing') return '/settings/billing'
      if (tab === 'EntityStatus') return '/settings/entities'
      return '/settings/company'
    }
  }
]
